export enum ConfirmacaoRetornoEnum {
    'VDP' = 'Você tem certeza que deseja solicitar retorno de Etapa para a VDP para esta Unidade Produtiva?',
    'PCNC' = 'Você tem certeza que deseja solicitar retorno de Etapa para a PCNC para esta Unidade Produtiva?',
    'VCP' = 'Você tem certeza que deseja solicitar retorno de Etapa para a VCP para esta Unidade Produtiva?',
    'emissão do Certificado' = 'Você tem certeza que deseja solicitar retorno de Etapa para a "Certificado em Emissão" para esta Unidade Produtiva?'
}